"use client";

import { useEffect, useState } from "react";
import { Box, Typography, styled } from "@mui/material";
import { Search, Mail, Building2, FileText } from "lucide-react";
import { SummarySkeleton } from "../skeletons/SummarySkeleton";

const MESSAGES = [
  { text: "Analysing candidate details", icon: Search },
  { text: "Preparing outreach recommendations", icon: Mail },
  { text: "Identifying suitable company recommendations", icon: Building2 },
  { text: "Generating candidate summary", icon: FileText },
];

const ROTATE_MS = 3500;

const Wrap = styled(Box)({
  position: "relative",
});

const Overlay = styled(Box)({
  position: "absolute",
  inset: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  pointerEvents: "none",
  textAlign: "center",
  padding: "0 16px",
  transform: "translateY(-14px)",
});

export default function SummaryLoading() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % MESSAGES.length);
    }, ROTATE_MS);
    return () => clearInterval(id);
  }, []);

  const Icon = MESSAGES[index].icon;

  return (
    <Wrap>
      <SummarySkeleton />
      <Overlay aria-live="polite">
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Icon size={16} color="var(--action-primary)" />
          <Typography
            variant="body1"
            sx={{ color: "var(--action-primary)", fontWeight: "var(--font-weight-medium)" }}
          >
            {MESSAGES[index].text}…
          </Typography>
        </Box>
      </Overlay>
    </Wrap>
  );
}
